// TexHub Translations - Business-adapted (not literal)
// Spanish (Mexico) / English (USA)

const translations = {
  // Common
  common: {
    es: {
      search: 'Buscar',
      login: 'Iniciar sesión',
      register: 'Registrarse',
      logout: 'Cerrar sesión',
      save: 'Guardar',
      cancel: 'Cancelar',
      edit: 'Editar',
      delete: 'Eliminar',
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      yes: 'Sí',
      no: 'No',
      back: 'Volver',
      next: 'Siguiente',
      previous: 'Anterior',
      viewMore: 'Ver más',
      viewAll: 'Ver todos',
      noResults: 'No se encontraron resultados',
      required: 'Requerido',
      optional: 'Opcional',
      free: 'Gratis',
      month: 'mes',
      year: 'año',
      days: 'días',
      contact: 'Contactar',
      message: 'Mensaje',
      send: 'Enviar',
      share: 'Compartir',
      download: 'Descargar',
      upload: 'Subir',
      verified: 'Verificada',
      featured: 'Destacada',
      new: 'Nuevo',
      price: 'Precio',
      quantity: 'Cantidad',
      total: 'Total',
      description: 'Descripción',
      category: 'Categoría',
      location: 'Ubicación',
      phone: 'Teléfono',
      email: 'Correo electrónico',
      website: 'Sitio web',
      address: 'Dirección',
    },
    en: {
      search: 'Search',
      login: 'Log in',
      register: 'Sign up',
      logout: 'Log out',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      yes: 'Yes',
      no: 'No',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      viewMore: 'View more',
      viewAll: 'View all',
      noResults: 'No results found',
      required: 'Required',
      optional: 'Optional',
      free: 'Free',
      month: 'month',
      year: 'year',
      days: 'days',
      contact: 'Contact',
      message: 'Message',
      send: 'Send',
      share: 'Share',
      download: 'Download',
      upload: 'Upload',
      verified: 'Verified',
      featured: 'Featured',
      new: 'New',
      price: 'Price',
      quantity: 'Quantity',
      total: 'Total',
      description: 'Description',
      category: 'Category',
      location: 'Location',
      phone: 'Phone',
      email: 'Email',
      website: 'Website',
      address: 'Address',
    }
  },

  // Navigation
  nav: {
    es: {
      home: 'Inicio',
      dashboard: 'Dashboard',
      search: 'Buscar',
      store: 'Tienda en línea',
      messages: 'Mensajes',
      profile: 'Mi Perfil',
      catalog: 'Catálogo',
      surplus: 'Saldos',
      blog: 'Blog Comunitario',
      plans: 'Planes',
      howItWorks: 'Cómo funciona',
      forSuppliers: 'Soy proveedor',
      forBuyers: 'Soy comprador',
      myStore: 'Mi Tienda',
      providers: 'Proveedores',
      manufacturers: 'Fabricantes',
      services: 'Maquileros/Servicios',
    },
    en: {
      home: 'Home',
      dashboard: 'Dashboard',
      search: 'Search',
      store: 'Online Store',
      messages: 'Messages',
      profile: 'My Profile',
      catalog: 'Catalog',
      surplus: 'Surplus',
      blog: 'Community Blog',
      plans: 'Pricing',
      howItWorks: 'How it works',
      forSuppliers: 'For Suppliers',
      forBuyers: 'For Buyers',
      myStore: 'My Store',
      providers: 'Suppliers',
      manufacturers: 'Manufacturers',
      services: 'Manufacturing Partners',
    }
  },

  // Landing Page
  landing: {
    es: {
      heroTitle: 'Conectamos a toda la industria textil',
      heroSubtitle: 'Crea tu tienda en línea, conecta con proveedores y maquileros.',
      heroCTA: 'Cotiza, compara y crece.',
      valueProps: {
        store: 'Tu tienda en línea',
        free: '100% gratis para empezar',
        noCommissions: 'Sin comisiones'
      },
      ctaButton: 'Crear mi cuenta gratis',
      ctaButtonSecondary: 'Ver demo',
      trustedBy: 'Confían en nosotros',
      promoBar: '¡Empieza gratis! Crea tu catálogo hoy',
      
      // How it works
      howItWorksTitle: '¿Cómo funciona?',
      howItWorksSubtitle: 'En 3 simples pasos conecta con toda la industria textil',
      steps: {
        step1Title: 'Regístrate gratis',
        step1Desc: 'Crea tu cuenta y completa el perfil de tu empresa en minutos',
        step2Title: 'Publica o busca',
        step2Desc: 'Publica tus productos o encuentra proveedores ideales',
        step3Title: 'Conecta y crece',
        step3Desc: 'Recibe cotizaciones y expande tu red de negocios'
      },
      
      // For Suppliers
      forSuppliersTitle: 'Para Proveedores',
      forSuppliersSubtitle: 'Aumenta tu visibilidad y genera más ventas',
      supplierBenefits: [
        'Muestra tu catálogo a miles de compradores',
        'Recibe cotizaciones directas',
        'Sin comisiones por venta',
        'Estadísticas de tu perfil'
      ],
      
      // For Buyers
      forBuyersTitle: 'Para Compradores',
      forBuyersSubtitle: 'Encuentra los mejores proveedores',
      buyerBenefits: [
        'Acceso a cientos de proveedores verificados',
        'Compara precios y calidad',
        'Solicita muestras fácilmente',
        'Historial de cotizaciones'
      ],
      
      // Online Store Section
      storeTitle: 'Tu tienda en línea profesional en minutos',
      storeSubtitle: 'Crea tu catálogo digital personalizado con tu marca. Recibe solicitudes de cotización directamente de compradores interesados, sin comisiones por venta.',
      storeFeatures: {
        customize: 'Personaliza tu marca',
        customizeDesc: 'Logo, colores, banner y URL propia',
        catalog: 'Catálogo ilimitado',
        catalogDesc: 'Sube productos con fotos, precios y variantes',
        leads: 'Genera leads',
        leadsDesc: 'Recibe cotizaciones y solicitudes de muestra',
        visibility: 'Visibilidad total',
        visibilityDesc: 'Aparece en búsquedas y comparte tu link'
      },
      storeCtaButton: 'Empieza gratis',
      storeCtaSecondary: 'Ver ejemplo',
      noCommissions: 'Sin comisiones',
      freeToStart: 'Gratis para empezar',
    },
    en: {
      heroTitle: 'The B2B Textile Marketplace',
      heroSubtitle: 'Create your online store, connect with suppliers and manufacturing partners.',
      heroCTA: 'Get quotes, compare, and grow.',
      valueProps: {
        store: 'Your online store',
        free: 'Free to get started',
        noCommissions: 'No commissions'
      },
      ctaButton: 'Get started free',
      ctaButtonSecondary: 'View demo',
      trustedBy: 'Trusted by leading companies',
      promoBar: 'Start free! Create your catalog today',
      
      // How it works
      howItWorksTitle: 'How it works',
      howItWorksSubtitle: 'Connect with the textile industry in 3 simple steps',
      steps: {
        step1Title: 'Sign up free',
        step1Desc: 'Create your account and complete your company profile in minutes',
        step2Title: 'List or search',
        step2Desc: 'Post your products or find ideal suppliers',
        step3Title: 'Connect and grow',
        step3Desc: 'Receive quote requests and expand your business network'
      },
      
      // For Suppliers
      forSuppliersTitle: 'For Suppliers',
      forSuppliersSubtitle: 'Increase visibility and generate more leads',
      supplierBenefits: [
        'Showcase your catalog to thousands of buyers',
        'Receive direct quote requests',
        'No sales commissions',
        'Profile analytics and insights'
      ],
      
      // For Buyers
      forBuyersTitle: 'For Buyers',
      forBuyersSubtitle: 'Find the best suppliers for your business',
      buyerBenefits: [
        'Access hundreds of verified suppliers',
        'Compare prices and quality',
        'Request samples easily',
        'Quote history and tracking'
      ],
      
      // Online Store Section
      storeTitle: 'Your professional online store in minutes',
      storeSubtitle: 'Create your custom digital catalog with your brand. Receive quote requests directly from interested buyers, with no sales commissions.',
      storeFeatures: {
        customize: 'Customize your brand',
        customizeDesc: 'Logo, colors, banner, and custom URL',
        catalog: 'Unlimited catalog',
        catalogDesc: 'Upload products with photos, prices, and variants',
        leads: 'Generate leads',
        leadsDesc: 'Receive quotes and sample requests',
        visibility: 'Full visibility',
        visibilityDesc: 'Appear in searches and share your link'
      },
      storeCtaButton: 'Start free',
      storeCtaSecondary: 'View example',
      noCommissions: 'No commissions',
      freeToStart: 'Free to start',
    }
  },

  // Pricing
  pricing: {
    es: {
      title: 'Planes y precios',
      subtitle: 'Elige el plan que mejor se adapte a tu negocio',
      monthly: 'Mensual',
      yearly: 'Anual',
      popular: 'Más popular',
      currentPlan: 'Plan actual',
      selectPlan: 'Seleccionar plan',
      startTrial: 'Activar PRO',
      trialDays: '',
      
      // Plan names
      basic: 'Free',
      gold: 'PRO',
      premium: 'PRO',
      
      // Plan descriptions
      basicDesc: 'Para empezar a explorar',
      goldDesc: 'Para negocios en crecimiento',
      premiumDesc: 'Para empresas establecidas',
      
      // Features
      features: {
        products: 'productos en catálogo',
        productsUnlimited: 'Productos ilimitados',
        quotes: 'Cotizaciones ilimitadas',
        support: 'Soporte prioritario',
        analytics: 'Estadísticas avanzadas',
        verified: 'Insignia verificado',
        featured: 'Posición destacada',
        storeProducts: 'productos en tienda',
        priceVisibility: 'Precios visibles',
        searchPriority: 'Prioridad en búsquedas'
      },
      
      guarantee: 'Cancela cuando quieras',
      questions: '¿Tienes preguntas?',
      contactUs: 'Contáctanos'
    },
    en: {
      title: 'Pricing Plans',
      subtitle: 'Choose the plan that fits your business',
      monthly: 'Monthly',
      yearly: 'Annual',
      popular: 'Most popular',
      currentPlan: 'Current plan',
      selectPlan: 'Select plan',
      startTrial: 'Activate PRO',
      trialDays: '',
      
      // Plan names
      basic: 'Free',
      gold: 'PRO',
      premium: 'PRO',
      
      // Plan descriptions
      basicDesc: 'To get started',
      goldDesc: 'For growing businesses',
      premiumDesc: 'For established companies',
      
      // Features
      features: {
        products: 'products in catalog',
        productsUnlimited: 'Unlimited products',
        quotes: 'Unlimited quotes',
        support: 'Priority support',
        analytics: 'Advanced analytics',
        verified: 'Verified badge',
        featured: 'Featured placement',
        storeProducts: 'products in store',
        priceVisibility: 'Visible pricing',
        searchPriority: 'Search priority'
      },
      
      guarantee: '30-day satisfaction guarantee',
      questions: 'Have questions?',
      contactUs: 'Contact us'
    }
  },

  // Dashboard
  dashboard: {
    es: {
      welcome: 'Hola',
      todaySummary: 'Aquí está tu resumen de hoy',
      activity: 'Tu actividad como proveedor',
      productsPublished: 'Productos publicados',
      inYourCatalog: 'en tu catálogo',
      quotesReceived: 'Cotizaciones recibidas',
      totalRequests: 'total de solicitudes',
      pendingSamples: 'Muestras pendientes',
      newMessages: 'Mensajes nuevos',
      recentActivity: 'Actividad reciente',
      quickActions: 'Acciones rápidas',
      addProduct: 'Agregar producto',
      viewCatalog: 'Ver catálogo',
      viewMessages: 'Ver mensajes',
      noCompany: 'Registra tu empresa',
      noCompanyDesc: 'Completa el registro de tu empresa para acceder a todas las funciones',
    },
    en: {
      welcome: 'Hello',
      todaySummary: "Here's your summary for today",
      activity: 'Your supplier activity',
      productsPublished: 'Products published',
      inYourCatalog: 'in your catalog',
      quotesReceived: 'Quote requests',
      totalRequests: 'total requests',
      pendingSamples: 'Pending samples',
      newMessages: 'New messages',
      recentActivity: 'Recent activity',
      quickActions: 'Quick actions',
      addProduct: 'Add product',
      viewCatalog: 'View catalog',
      viewMessages: 'View messages',
      noCompany: 'Register your company',
      noCompanyDesc: 'Complete your company registration to access all features',
    }
  },

  // Store
  store: {
    es: {
      myStore: 'Mi Tienda',
      createStore: 'Crea tu Tienda en Línea',
      createStoreDesc: 'Muestra tus productos a miles de compradores potenciales en la industria textil.',
      createStoreButton: 'Crear mi Tienda',
      customize: 'Personalizar',
      viewStore: 'Ver tienda',
      products: 'Productos',
      requests: 'Solicitudes',
      visits: 'Visitas',
      visiblePrices: 'Precios visibles',
      addProduct: 'Agregar producto',
      editProduct: 'Editar producto',
      deleteProduct: 'Eliminar producto',
      productName: 'Nombre del producto',
      productCategory: 'Categoría',
      productPrice: 'Precio',
      productDescription: 'Descripción',
      productImages: 'Imágenes',
      moq: 'Pedido mínimo',
      stock: 'Stock disponible',
      tags: 'Etiquetas',
      
      // Customization
      customizeTitle: 'Personalizar Tienda',
      customizeDesc: 'Configura la apariencia y datos de contacto de tu tienda',
      general: 'General',
      design: 'Diseño',
      contactTab: 'Contacto',
      storeName: 'Nombre de la tienda',
      storeUrl: 'URL de tu tienda',
      logo: 'Logo',
      cover: 'Portada',
      colors: 'Colores de la tienda',
      primaryColor: 'Color primario',
      secondaryColor: 'Color secundario',
      bannerText: 'Texto promocional',
      preview: 'Vista previa de tu tienda',
      saveChanges: 'Guardar cambios',
      
      // Leads
      newRequests: 'Solicitudes nuevas',
      quote: 'Cotización',
      sample: 'Muestra',
      contactRequest: 'Contacto',
      markAsRead: 'Marcar como leído',
      respond: 'Responder',
      
      // Public store
      contactSupplier: 'Contactar proveedor',
      requestQuote: 'Solicitar cotización',
      requestSample: 'Solicitar muestra',
      searchProducts: 'Buscar productos...',
      productsFound: 'productos encontrados',
      noProducts: 'Esta tienda aún no tiene productos',
      storeNotFound: 'Tienda no encontrada',
      storeNotFoundDesc: 'La tienda que buscas no existe o no está disponible',
      backToHome: 'Volver al inicio',

      // Features
      featureCatalog: 'Catálogo de Productos',
      featureCatalogDesc: 'Sube fotos y detalles',
      featureVisibility: 'Visibilidad',
      featureVisibilityDesc: 'Aparece en búsquedas',
      featureLeads: 'Genera Leads',
      featureLeadsDesc: 'Recibe solicitudes',
    },
    en: {
      myStore: 'My Store',
      createStore: 'Create Your Online Store',
      createStoreDesc: 'Showcase your products to thousands of potential buyers in the textile industry.',
      createStoreButton: 'Create my Store',
      customize: 'Customize',
      viewStore: 'View store',
      products: 'Products',
      requests: 'Inquiries',
      visits: 'Visits',
      visiblePrices: 'Visible pricing',
      addProduct: 'Add product',
      editProduct: 'Edit product',
      deleteProduct: 'Delete product',
      productName: 'Product name',
      productCategory: 'Category',
      productPrice: 'Price',
      productDescription: 'Description',
      productImages: 'Images',
      moq: 'Minimum order',
      stock: 'Stock available',
      tags: 'Tags',
      
      // Customization
      customizeTitle: 'Customize Store',
      customizeDesc: 'Configure the appearance and contact info of your store',
      general: 'General',
      design: 'Design',
      contactTab: 'Contact',
      storeName: 'Store name',
      storeUrl: 'Your store URL',
      logo: 'Logo',
      cover: 'Cover image',
      colors: 'Store colors',
      primaryColor: 'Primary color',
      secondaryColor: 'Secondary color',
      bannerText: 'Promotional text',
      preview: 'Preview of your store',
      saveChanges: 'Save changes',
      
      // Leads
      newRequests: 'New inquiries',
      quote: 'Quote',
      sample: 'Sample',
      contactRequest: 'Contact',
      markAsRead: 'Mark as read',
      respond: 'Respond',
      
      // Public store
      contactSupplier: 'Contact supplier',
      requestQuote: 'Request quote',
      requestSample: 'Request sample',
      searchProducts: 'Search products...',
      productsFound: 'products found',
      noProducts: 'This store has no products yet',
      storeNotFound: 'Store not found',
      storeNotFoundDesc: 'The store you are looking for does not exist or is not available',
      backToHome: 'Back to home',

      // Features
      featureCatalog: 'Product Catalog',
      featureCatalogDesc: 'Upload photos and details',
      featureVisibility: 'Visibility',
      featureVisibilityDesc: 'Appear in searches',
      featureLeads: 'Generate Leads',
      featureLeadsDesc: 'Receive inquiries',
    }
  },

  // Search
  search: {
    es: {
      title: 'Buscar',
      placeholder: 'Buscar productos, proveedores...',
      filters: 'Filtros',
      clearFilters: 'Limpiar filtros',
      results: 'resultados',
      
      // Tabs
      catalog: 'Catálogo',
      stores: 'Tiendas',
      suppliers: 'Proveedores',
      manufacturers: 'Fabricantes',
      services: 'Maquileros',
      
      // Filters
      category: 'Categoría',
      location: 'Ubicación',
      priceRange: 'Rango de precio',
      availability: 'Disponibilidad',
      verified: 'Solo verificados',
      
      // Product card
      quotePrice: 'Precio bajo cotización',
      sampleAvailable: 'Muestra disponible',
      viewProduct: 'Ver producto',
      viewSupplier: 'Ver proveedor',
    },
    en: {
      title: 'Search',
      placeholder: 'Search products, suppliers...',
      filters: 'Filters',
      clearFilters: 'Clear filters',
      results: 'results',
      
      // Tabs
      catalog: 'Catalog',
      stores: 'Stores',
      suppliers: 'Suppliers',
      manufacturers: 'Manufacturers',
      services: 'Manufacturing Partners',
      
      // Filters
      category: 'Category',
      location: 'Location',
      priceRange: 'Price range',
      availability: 'Availability',
      verified: 'Verified only',
      
      // Product card
      quotePrice: 'Price on request',
      sampleAvailable: 'Sample available',
      viewProduct: 'View product',
      viewSupplier: 'View supplier',
    }
  },

  // Categories
  categories: {
    es: {
      telas: 'Telas',
      hilos: 'Hilos y Hilazas',
      avios: 'Avíos y Accesorios',
      maquinaria: 'Maquinaria',
      quimicos: 'Químicos y Colorantes',
      etiquetas: 'Etiquetas y Empaques',
      servicios: 'Servicios de Maquila',
      confeccion: 'Confección',
      textilHogar: 'Textil Hogar',
      ropa: 'Ropa y Prendas',
    },
    en: {
      telas: 'Fabrics',
      hilos: 'Yarns & Threads',
      avios: 'Trims & Accessories',
      maquinaria: 'Machinery',
      quimicos: 'Chemicals & Dyes',
      etiquetas: 'Labels & Packaging',
      servicios: 'Manufacturing Services',
      confeccion: 'Apparel Manufacturing',
      textilHogar: 'Home Textiles',
      ropa: 'Clothing & Garments',
    }
  },

  // Auth
  auth: {
    es: {
      loginTitle: 'Iniciar sesión',
      loginSubtitle: 'Ingresa a tu cuenta de TexHub',
      registerTitle: 'Crear cuenta',
      registerSubtitle: 'Únete a la comunidad textil más grande',
      email: 'Correo electrónico',
      password: 'Contraseña',
      confirmPassword: 'Confirmar contraseña',
      forgotPassword: '¿Olvidaste tu contraseña?',
      rememberMe: 'Recordar sesión',
      noAccount: '¿No tienes cuenta?',
      hasAccount: '¿Ya tienes cuenta?',
      orContinueWith: 'O continúa con',
      termsAgree: 'Al registrarte, aceptas nuestros',
      terms: 'Términos y Condiciones',
      privacy: 'Política de Privacidad',
    },
    en: {
      loginTitle: 'Log in',
      loginSubtitle: 'Sign in to your TexHub account',
      registerTitle: 'Create account',
      registerSubtitle: 'Join the largest textile community',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      forgotPassword: 'Forgot password?',
      rememberMe: 'Remember me',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      orContinueWith: 'Or continue with',
      termsAgree: 'By signing up, you agree to our',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
    }
  },

  // Errors and messages
  messages: {
    es: {
      loginSuccess: 'Sesión iniciada correctamente',
      loginError: 'Credenciales inválidas',
      registerSuccess: 'Cuenta creada correctamente',
      registerError: 'Error al crear cuenta',
      saveSuccess: 'Guardado correctamente',
      saveError: 'Error al guardar',
      deleteSuccess: 'Eliminado correctamente',
      deleteError: 'Error al eliminar',
      uploadSuccess: 'Archivo subido correctamente',
      uploadError: 'Error al subir archivo',
      sendSuccess: 'Mensaje enviado',
      sendError: 'Error al enviar mensaje',
      requiredFields: 'Por favor completa todos los campos requeridos',
      invalidEmail: 'Correo electrónico inválido',
      passwordMismatch: 'Las contraseñas no coinciden',
      sessionExpired: 'Tu sesión ha expirado',
    },
    en: {
      loginSuccess: 'Logged in successfully',
      loginError: 'Invalid credentials',
      registerSuccess: 'Account created successfully',
      registerError: 'Error creating account',
      saveSuccess: 'Saved successfully',
      saveError: 'Error saving',
      deleteSuccess: 'Deleted successfully',
      deleteError: 'Error deleting',
      uploadSuccess: 'File uploaded successfully',
      uploadError: 'Error uploading file',
      sendSuccess: 'Message sent',
      sendError: 'Error sending message',
      requiredFields: 'Please complete all required fields',
      invalidEmail: 'Invalid email',
      passwordMismatch: 'Passwords do not match',
      sessionExpired: 'Your session has expired',
    }
  },

  // Footer
  footer: {
    es: {
      about: 'Sobre nosotros',
      aboutDesc: 'TexHub es la plataforma B2B líder para la industria textil en México.',
      contact: 'Contacto',
      legal: 'Legal',
      terms: 'Términos y Condiciones',
      privacy: 'Política de Privacidad',
      rights: 'Todos los derechos reservados',
      followUs: 'Síguenos',
    },
    en: {
      about: 'About us',
      aboutDesc: 'TexHub is the leading B2B platform for the textile industry.',
      contact: 'Contact',
      legal: 'Legal',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      rights: 'All rights reserved',
      followUs: 'Follow us',
    }
  }
};

// Helper function to get translation
export const getTranslation = (section, key, language = 'es') => {
  const sectionData = translations[section];
  if (!sectionData) return key;
  
  const langData = sectionData[language] || sectionData['es'];
  if (!langData) return key;
  
  // Handle nested keys like 'steps.step1Title'
  const keys = key.split('.');
  let value = langData;
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key;
    }
  }
  
  return value || key;
};

// Hook-friendly translation function creator
export const createT = (language) => (section, key) => {
  return getTranslation(section, key, language);
};

export default translations;
